export default function customError(error, customMessage) {
  const { message, config } = error
  error.message = `${customMessage}. Url: '${(config && config.url) || 'Unknown'}'. Message: ${message}`
  return error
}

/**
 * Validate that an object contains keys from only the expected keys array, and no others.
 * Does not check for missing keys, only unexpected keys
 */
export function validateKeys(obj, expectedKeys) {
  if (!obj) return
  const keys = Object.keys(obj)
  keys.forEach((key) => {
    if (!expectedKeys.includes(key))
      throw new Error(`Unexpected key in object: ${key}, valid keys are: (${expectedKeys})`)
  })
}
